import React from 'react';
import styles from './Footer.module.css';

const Footer = (props) => (
  <footer
    data-testid="footer"
    className={styles.footer}
    style={{
      justifyContent: props.end ? "flex-end" : "flex-start", ...props.style
    }}>
    <span>SomaLabs <small>{new Date().getFullYear()}</small></span>
    <span>
      <a target='_blank' rel="noreferrer" href='https://api.mziq.com/mzfilemanager/v2/d/dd835c95-0412-4284-82db-dae5784acebc/f26ac65d-a5a7-b53f-d4e8-644726e03d67?origin=2'>
        Política de Privacidade.
      </a>
    </span>
  </footer>
);

export default Footer;
